import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Stack } from '@mui/material';
import closeIcon from '../Assets/images/close_red.png';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const LeadDialog = ({checked, open, handleClose, handleSave,selectionModel,  title, alternateBtnLabel = "", children, size, btnlabel,autoFocusBtn = false }) => {
  
  return (
    <div>
       <Dialog
          fullWidth={true}
          maxWidth= {size}
          open={open}
          onClose={handleClose}
          disableRestoreFocus 
      >
        <DialogTitle style={{display: "flex", alignItems:'center', justifyContent: "space-between", padding: "10px"}}>
            <Typography variant='h6' gutterBottom>
              {title}
            </Typography>
            <IconButton>
              <img onClick={handleClose} src={closeIcon} style={{height: "35px",}}/>
            </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {children}
        </DialogContent>
        <DialogActions>
          <Stack display={"flex"} alignItems={"center"} justifyContent={"center"} width={"100%"} flexDirection={"row"}>
           { btnlabel &&
              <Button className="edit-primary mr-20 btn-search" disabled={checked ? selectionModel?.length === 0 : false} autoFocus={autoFocusBtn} onClick={handleSave}>
              {btnlabel}
            </Button>
}
          {alternateBtnLabel && <Button className="edit-primary ml-20 btn-search reset-btn"  onClick={handleClose}>
            {alternateBtnLabel}
          </Button>
        }
        </Stack>
          
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default LeadDialog;
